export const QUERY_COMPLETE = "QUERY_COMPLETE";
export const TAGS_QUERY_COMPLETE = "TAGS_QUERY_COMPLETE";
export const QUERY_ERROR = "QUERY_ERROR";
export const SELECT_SIDEBAR_TAB = "SELECT_SIDEBAR_TAB";
export const FILTER_ITEM_USER_SEARCH = "FILTER_ITEM_USER_SEARCH";
